import { DataGrid, type DataGridProps } from '@shared/components';
import { useState } from 'react';

import { columns } from './column';
export type BaseQSetReviewResultListProps = Omit<DataGridProps, 'columns'>;

const PAGE_SIZE_OPTIONS = [100];

export default function BaseQSetReviewResultList(props: BaseQSetReviewResultListProps) {
  const { rows, ...rest } = props;
  const rowCount = rows?.length ?? 0;

  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 100 });

  return (
    <DataGrid
      {...rest}
      rows={rows}
      columns={columns}
      pageSizeOptions={PAGE_SIZE_OPTIONS}
      paginationModel={paginationModel}
      onPaginationModelChange={setPaginationModel}
      hideFooter={!rowCount}
      slotProps={{
        footer: {
          total: rowCount,
          pagination: {
            count: rowCount,
            page: paginationModel.page,
            rowsPerPage: paginationModel.pageSize,
            rowsPerPageOptions: [],
            onPageChange: (_: unknown, page: number) =>
              setPaginationModel((prev) => ({ ...prev, page })),
          },
        },
      }}
      rowHeight={48}
      rowSelection={false}
      disableColumnMenu
      sx={(theme) => ({
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.spacing(2),
        border: `1px solid ${theme.palette.grey[300]}`,
        '& .MuiDataGrid-columnHeaders': {
          backgroundColor: theme.palette.grey[100],
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '& .MuiDataGrid-row .MuiDataGrid-cell': {
          padding: theme.spacing(3),
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
          ...theme.typography.body2,
        },
      })}
    />
  );
}
